import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * The one page-title style, used on every page: the display face (Inter) in flat
 * black at a medium (not bold) weight — clean and readable, matching the landing.
 * Keeps headings consistent across Profile, Meetings, Connections, Admin, and the rest.
 */
export function PageTitle({
  children,
  className,
  as: Tag = "h1",
}: {
  children: React.ReactNode;
  className?: string;
  as?: "h1" | "h2";
}) {
  return (
    <Tag
      className={cn(
        "font-display text-2xl font-medium leading-tight tracking-tight text-foreground sm:text-3xl",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
